import { loadState, saveState } from '../helpers/localStorage'

// Cambiar por uuid library?
const generateId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const sessionUtil = ({ sessionTimeoutMs = 1000 * 60 * 30 } = {}) => {
  let state = loadState() || {
    clientId: generateId(),
    sessionNumber: 0,
    sessionId: null,
    lastActivity: 0,
    pageviews: 0
  }

  if (!state.clientId) state.clientId = generateId()

  const startNewSession = () => {
    state.sessionNumber = state.sessionNumber + 1
    state.sessionId = generateId()
    state.lastActivity = Date.now()
    state.pageviews = 0
    saveState(state)
    return state
  }

  const persistCheckoutVariant = (variant) => {
    try {
      const existing = loadState() || state
      existing.variant = variant
      saveState(existing)
      state = Object.assign({}, state, existing)
    } catch (e) {
      console.warn('persistCheckoutVariant error', e)
    }
  }

  const isSessionActive = () => {
    const inactivity = Date.now() - state.lastActivity
    if (!state.sessionId || inactivity > sessionTimeoutMs) {
      startNewSession()
    } else {
      state.lastActivity = Date.now()
      saveState(state)
    }
    return state
  }

  const getClientId = () => {
    return state.clientId
  }

  const getSessionId = () => {
    isSessionActive()
    return state.sessionId
  }

  const getSessionNumber = () => {
    isSessionActive()
    return state.sessionNumber
  }

  const getCheckoutVariant = () => {
    const st = loadState()
    return st?.variant || null
  }

  return {
    getClientId,
    getSessionId,
    getSessionNumber,
    persistCheckoutVariant,
    getCheckoutVariant
  }
}
